import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTE_CONSTANTS } from "../constants/routeConstants";
import { DataContext } from "../dataContext";
import { ReactComponent as ChevronRight } from "../assets/ico_chevron_right.svg";

const { SET_DEFAULT_ACCOUNT, PEOPLE } = ROUTE_CONSTANTS;

const Settings = () => {
  const { defaultAccounts, defaultAccountsLoading, cards, identifiers } =
    useContext(DataContext);
  const navigate = useNavigate();

  const identifierTypes = [
    ...new Set(
      identifiers
        .sort((a, b) => a.type.localeCompare(b.type))
        .map(({ type }) => type)
    ),
  ];

  return (
    <main className="page_with_nav" style={{ justifyContent: "flex-start" }}>
      {identifiers.length && defaultAccounts.length ? (
        <div>
          {identifierTypes.map((identifierType) => {
            return (
              <div
                key={identifierType}
                style={
                  identifierType === identifierTypes[0]
                    ? { marginTop: "10px" }
                    : { marginTop: "30px" }
                }
              >
                <div className="np-group-header">
                  Default card for {identifierType}
                </div>
                {identifiers
                  .filter(({ type }) => type === identifierType)
                  .map((identifier) => {
                    let defaultCardForIdentifier = undefined;
                    defaultAccounts.find((accounts) => {
                      defaultCardForIdentifier = accounts[1].find(
                        ({ value }) => value === identifier.value
                      );
                      return defaultCardForIdentifier;
                    });
                    return (
                      <div
                        key={identifier.value}
                        className="status"
                        style={{
                          marginTop: "10px",
                          alignItems: "center",
                        }}
                        onClick={() =>
                          navigate(
                            SET_DEFAULT_ACCOUNT.replace(":id", identifier.value)
                          )
                        }
                      >
                        <div className="np-list-body">
                          <div className="np-list-title">{identifier.value}</div>
                          <div className="np-list-sub">
                            {defaultCardForIdentifier ? (
                              <>
                                {cards.find(
                                  (card) =>
                                    defaultCardForIdentifier.default_card ===
                                    card.uuid
                                )?.last_four ? (
                                  <>
                                    {/* 1st choice is show the card last_four */}
                                    Card Ending{" "}
                                    {
                                      cards.find(
                                        (card) =>
                                          defaultCardForIdentifier.default_card ===
                                          card.uuid
                                      )?.last_four
                                    }
                                  </>
                                ) : (
                                  <>
                                    {/* 2nd choice is show the account name */}
                                    {
                                      defaultAccounts.find((arr) =>
                                        arr[1].find(
                                          ({ value }) =>
                                            value === identifier.value
                                        )
                                      )[0].name
                                    }
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                {/* Final choice is show this if there's no account or card */}
                                Another account and/or institution
                              </>
                            )}
                          </div>
                        </div>
                        <ChevronRight className="stroke_sending_text_primary" />
                      </div>
                    );
                  })}
              </div>
            );
          })}
        </div>
      ) : (
        <h3 className="center_page_with_nav">
          {defaultAccountsLoading ? (
            <>Account and settings data is loading.</>
          ) : (
            <>Something went wrong while fetching account and settings data.</>
          )}
        </h3>
      )}

      {/* Payee Management POC: favorites and recent recipients live on the People screen. */}
      <section style={{ marginTop: "30px" }} aria-labelledby="people_label">
        <div className="np-group-header" id="people_label">
          People
        </div>
        <div
          className="status"
          style={{ marginTop: "10px", alignItems: "center" }}
          onClick={() => navigate(PEOPLE)}
          data-cy="settings_people"
        >
          <div className="np-list-body">
            <div className="np-list-title">Favorites and recent</div>
            <div className="np-list-sub">Name, reorder and remove the people you send to</div>
          </div>
          <ChevronRight className="stroke_sending_text_primary" />
        </div>
      </section>

    </main>
  );
};

export default Settings;
